import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/cn";

type Dados = { titulo?: string | null; validadeAte?: Date | null; observacoes?: string | null };

const campo =
  "h-8 w-full rounded-md border border-zinc-200 bg-white px-2 text-sm text-zinc-900 disabled:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground";
const rotulo = "space-y-1 text-xs font-medium text-zinc-500";

/** "Dados do orçamento" (título, validade, observações) — usados de vez em quando, então fechado. */
export function DadosDoPlano({
  titulo,
  validadeAte,
  observacoes,
  podeMontar,
  onAtualizar,
}: {
  titulo: string | null;
  validadeAte: Date | string | null;
  observacoes: string | null;
  podeMontar: boolean;
  onAtualizar: (dados: Dados) => void;
}) {
  const preenchidos = [titulo, validadeAte, observacoes].filter(Boolean).length;
  const [aberto, setAberto] = useState(false);
  return (
    <div className="rounded-lg border border-zinc-200 dark:border-border">
      <button
        type="button"
        aria-expanded={aberto}
        onClick={() => setAberto((v) => !v)}
        className="flex w-full items-center justify-between px-3 py-2 text-left text-[12.5px] font-medium text-zinc-700 hover:bg-zinc-50 dark:text-foreground dark:hover:bg-muted/40"
      >
        <span>
          Dados do orçamento
          <span className="ml-1.5 font-normal text-zinc-400">
            {preenchidos ? `${preenchidos} preenchido${preenchidos > 1 ? "s" : ""}` : "título, validade, observações"}
          </span>
        </span>
        <ChevronDown className={cn("h-3.5 w-3.5 text-zinc-400 transition-transform", aberto && "rotate-180")} />
      </button>
      {aberto && (
        <div className="grid grid-cols-2 gap-3 border-t border-zinc-100 p-3 dark:border-border">
          <label className={rotulo}>
            Título
            <input
              key={`t${titulo}`}
              defaultValue={titulo ?? ""}
              disabled={!podeMontar}
              placeholder="Ex.: Reabilitação superior"
              onBlur={(e) => e.target.value !== (titulo ?? "") && onAtualizar({ titulo: e.target.value || null })}
              className={campo}
            />
          </label>
          <label className={rotulo}>
            Válido até
            <input
              type="date"
              value={validadeAte ? new Date(validadeAte).toISOString().slice(0, 10) : ""}
              disabled={!podeMontar}
              onChange={(e) => onAtualizar({ validadeAte: e.target.value ? new Date(`${e.target.value}T12:00:00`) : null })}
              className={campo}
            />
          </label>
          <label className={`${rotulo} col-span-2`}>
            Observações (saem no orçamento)
            <textarea
              key={`o${observacoes}`}
              defaultValue={observacoes ?? ""}
              disabled={!podeMontar}
              rows={2}
              onBlur={(e) => e.target.value !== (observacoes ?? "") && onAtualizar({ observacoes: e.target.value || null })}
              className={`${campo} h-auto py-1.5`}
            />
          </label>
        </div>
      )}
    </div>
  );
}
